module.exports = __webpack_public_path__ + "image/header-icon1.png";